import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { FeedbackDialogParams, FeedbackCategory } from '../components/InlineFeedbackDialog';

export function shouldShowContentDonationText(feedbackDialogParams: FeedbackDialogParams): boolean {
    if (
        isConsumer() &&
        feedbackDialogParams.donationText &&
        feedbackDialogParams.donationText.length > 0
    ) {
        if (feedbackDialogParams.donationJson) {
            return true;
        } else {
            console.warn(
                'Inline Feedback Dialog Error : For donating the content to ODS, donationJson cannot be empty.'
            );
        }
    }
    return false;
}

export function sliceCategories(categories: FeedbackCategory[]): FeedbackCategory[] {
    let slicedCategories = categories;

    if (categories) {
        if (categories.length > 6) {
            slicedCategories = categories.slice(0, 6);
            console.warn(
                'Inline Feedback Dialog Error : The number of Categories cannot be more than 6. Only the first 6 Categories will be shown in the Dialog.'
            );
        }
    }

    return slicedCategories;
}

export function sliceCategory(category: string): string {
    let slicedCategory = category;

    if (category.length > 50) {
        slicedCategory = category.slice(0, 50).concat('...');
        console.warn(
            'Inline Feedback Dialog Error : The length of each category cannot be more than 50 characters. Only the first 50 characters will be shown in the Dialog.'
        );
    }

    return slicedCategory;
}
